module.exports = __webpack_public_path__ + "img/google-icon.15249724.png";